export const dateFormat = (date: Date) => {
  try {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const hour = `0${date.getHours()}`.slice(-2);
    const min = `0${date.getMinutes()}`.slice(-2);
    const sec = `0${date.getSeconds()}`.slice(-2);
    return `${year}年${month}月${day}日 ${hour}時${min}分${sec}秒`;
  } catch (e) {
    return "";
  }
};
